import { render } from "./LogoutModal.vue?vue&type=template&id=3fc32f72&scoped=true&ts=true"
import script from "./LogoutModal.vue?vue&type=script&lang=ts"
export * from "./LogoutModal.vue?vue&type=script&lang=ts"

import "./LogoutModal.vue?vue&type=style&index=0&id=3fc32f72&lang=css"
import "./LogoutModal.vue?vue&type=style&index=1&id=3fc32f72&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc32f72"]])

export default __exports__